
    <!-- [class]="options?.htmlClass || ''"-->
    <div [class.floatLabelContainer]="true">
      <label *ngIf="options?.title"
        [attr.for]="'control' + layoutNode?._id"
        [class]="options?.labelHtmlClass || ''"
        [style.display]="options?.notitle ? 'none' : ''"
        [innerHTML]="options?.title"></label>
      <!-- email input tag is to autofill the content default -->
      <input type="email" name="email_autofill" value="" style="display:none;" />
      <input float-label
        [formControl]="formControl"
        [attr.aria-describedby]="'control' + layoutNode?._id + 'Status'"
        [attr.list]="'control' + layoutNode?._id + 'Autocomplete'"
        [attr.maxlength]="options?.maxLength"
        [attr.minlength]="options?.minLength"
        [attr.pattern]="options?.pattern"
        [attr.placeholder]="options?.placeholder"
        [attr.required]="options?.required"
        [class]="options?.fieldHtmlClass || ''"
        [disabled]="controlDisabled"
        [id]="'control' + layoutNode?._id"
        [name]="controlName"
        [readonly]="options?.readonly ? 'readonly' : null"
        [type]="layoutNode?.type"
        [value]="controlValue"
        [mask]="options?.maskFormat"
        (input)="updateValue($event);focusInputOnChange();validateInputValue($event)" (keypress)="onChange()" (keydown)="onChange()"
        (keyup)="removeError();onChange()" (paste)="onChange()" (blur)=validateInputValue($event)>
        <datalist *ngIf="options?.typeahead?.source"
          [id]="'control' + layoutNode?._id + 'Autocomplete'">
          <option *ngFor="let word of options?.typeahead?.source" [value]="word">
        </datalist>
        <!-- Email verification spinner block start -->
        <span *ngIf="layoutNode?.name==='email' && isShowLoader" tabindex="0" class="personal-info--email-info">
        <i class="fa fa-spinner"></i></span>
        <!-- Email verification spinner block end -->
        <!-- Government Id verification spinner block start -->
        <span *ngIf="(layoutNode?.name==='governmentId' || layoutNode?.name=== 'accountNumber') && isShowGovernmentIdLoader" tabindex="0" class="personal-info--email-info">
        <i class="fa fa-spinner"></i></span>
        <!-- Government Id verification spinner block end -->
    </div>
    <span *ngIf="!formControl.hasError('required') && emailError && (!isShowLoader)"
    [class]="'error custom-error'">{{'schemaform.There is an existing account registered with this email-id in our system, A unique value is required to proceed'
    |translate |translateKey }}</span>
    <span *ngIf="!formControl.hasError('required') && customMessage && (!isShowLoader || !isShowGovernmentIdLoader)"
    [class]="'error custom-error'">{{customMessage}}</span>


// WEBPACK FOOTER //
// ./src/app/customerservice/widgets/custom-textbox.widget.ts.CustomInputComponent.html